const MinusSignCircleIcon = /*#__PURE__*/ [
  ["path", { d: "M16 12H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export { MinusSignCircleIcon as default };
//# sourceMappingURL=MinusSignCircleIcon.js.map
